import { AppPageComponent } from '../../shared/ui/app-page/app-page.component';
import { EmployeeScore } from '../shared/models';
import { EmployeesService } from '../shared/services';
import { EmployeesFilter, EmployeeInvoicesFilter } from '../shared';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { HeaderAction, TopLevelComponent, IdName } from '../../shared/models';
import { Store, StoreHelper, UserService } from '../../shared/services';
import { EmployeesFilterSheetComponent } from '../shared';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'my-scores',
    template: require('./scores.component.pug'),
    styles: [
        require('./scores.component.scss')
    ],
})
export class ScoresComponent extends TopLevelComponent implements OnDestroy {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(EmployeesFilterSheetComponent) filterSheet;

    fg = new FormGroup({});
    scores$: Observable<EmployeeScore[]>;
    showScoreDetails = false;
    selectedEmployee: IdName;

    private _searchAction = { id: 'search', icon: 'search' };
    private _employeesFilter: EmployeesFilter;
    private _filterReady: boolean = false;
    private _preloaderSubs: Subscription;

    constructor(
        private _employeesService: EmployeesService,
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService,
        private _router: Router) {

        super(store, storeHelper, userService);

        // set title and actions
        this.headerTitle = 'Scores';
        this.headerActions = [this._searchAction];
        this.subscribeToHeaderActions(this._reactToHeaderAction);
    }

    ngOnDestroy() {
        this._preloaderSubs.unsubscribe();
    }

    onFilterChanged(filter: EmployeesFilter) {
        this._employeesFilter = filter;

        if (this._employeesFilter.locationsSelection.locations.length > 0) {
            this._loadScores();

        } else {
            this._resetScoreData();
            this.empty = true;

            setTimeout(() => this.filterSheet.toggle(), 1500);

            if (this._filterReady) {
                this.filterSheet.toggle();
            }

            this._filterReady = true;
        }
    }

    showInvoices(score: EmployeeScore) {
        if (score.sales === 0) {
            return;
        }

        let filter = new EmployeeInvoicesFilter(this._employeesFilter, score.employee);

        this.storeHelper.update('employeeInvoicesFilter', filter);
        this.selectedEmployee = score.employee;
        this.showScoreDetails = true;
    }

    coverClosed() {
        this.showScoreDetails = false;
        this.headerTitle = 'Scores';
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id) {
            this.filterSheet.toggle();
        }
    }

    private _loadScores() {
        let that = this;
        this.empty = false;
        this.appPage.activatePreloader();

        this.scores$ = this._employeesService.getScores(this._employeesFilter);
        this._preloaderSubs = this.scores$.subscribe(res => {
            that.appPage.deactivatePreloader();
            this.empty = res.length <= 0;

            if (this.empty) {
                setTimeout(() => this.filterSheet.toggle(), 1500);
            }
        });

        if (this._filterReady) {
            this.filterSheet.toggle();
        }

        this._filterReady = true;
    }

    private _resetScoreData() {
        this.scores$.subscribe(i => i.splice(0));
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/scores/scores.component.ts